import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { selectConversations } from '../../redux/reducers/conversationReducer';
import { BouncingText } from '../../theme/CustomComponents';
import { Message } from '../../Types/conversation';
import ChatReactMarkdown from './ChatReactMarkdown';

const ChatReasoning = ({ message }: { message: Partial<Message> }) => {
  const { isLoading } = useSelector(selectConversations);
  const [showReasoningSummary, setShowReasoningSummary] = useState(true);

  if (!message.reasoningSummary) {
    return null;
  }

  return (
    <Typography variant="caption2" sx={{ fontStyle: 'italic' }}>
      <button
        onClick={() => setShowReasoningSummary((prev) => !prev)}
        style={{
          background: 'none',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          padding: 0,
          fontSize: '1rem',
          color: 'gray',
        }}
      >
        <span
          style={{
            display: 'inline-block',
            transition: 'transform 0.2s',
            transform: showReasoningSummary ? 'rotate(90deg)' : 'rotate(0deg)',
            marginRight: '6px',
          }}
        >
          ▶
        </span>
        <span style={{ display: 'inline-block', marginLeft: '2px' }}>
          {Array.from('Thinking Summary').map((char, idx) => (
            <BouncingText
              key={idx}
              idx={idx}
              shouldBounce={(isLoading && message.reasoningSummary && !message.message) as boolean}
            >
              {char === ' ' ? <>&nbsp;</> : char}
            </BouncingText>
          ))}
        </span>
      </button>
      {showReasoningSummary && (
        <div style={{ marginLeft: '24px', marginTop: '4px' }}>
          <ChatReactMarkdown message={{ message: message.reasoningSummary }} />
        </div>
      )}
    </Typography>
  );
};

export default ChatReasoning;
